import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const CommonDrawerComponent = lazy(() => import('../components/drawer'));


const AppRoute = () => {
    return (
        <>
            <Suspense fallback={<><LoaderText /></>}>
                <Routes>
                    <Route path='/auth/*' element={<AuthRoute />}></Route>
                    <Route path='/admin/*' element={<AdminRoute />}></Route>
                    <Route path='/login' element={<Navigate to='/auth/login' />}></Route>
                    <Route path='/user/*' element={<UserRoute />}></Route>
                    <Route path='*' element={<GuestRoute />}></Route>
                </Routes>
            </Suspense>
            <CommonDrawerComponent/>
        </>
    )
}

export default AppRoute;